// Exhibitions — add/edit events here. An event automatically moves to
// "Past exhibitions" once its `end` date has passed (no other change needed).
// `dates` is the display string; `end` (YYYY-MM-DD) drives the automatic switch.
export const EVENTS = [
  {
    id: "tei-2026",
    name: "TEI — Trade Expo Indonesia",
    dates: "October 14–18, 2026",
    end: "2026-10-18",
    venue: "ICE BSD City, Tangerang",
    photo: "/event-tei-2026.webp",
  },
  {
    id: "interfood-2026",
    name: "KRISTA Interfood",
    dates: "November 4–7, 2026",
    end: "2026-11-07",
    venue: "NICE PIK 2, Jakarta",
    booth: "Hall B - BS033",
    photo: "/event-interfood-2026.webp",
  },
  {
    id: "fiasia-2026",
    name: "Fi Asia Indonesia 2026",
    dates: "September 16–18, 2026",
    end: "2026-09-18",
    venue: "JIExpo Kemayoran, Jakarta",
    photo: "/event-fiasia-2026.webp",
  },
  {
    id: "sial-2024",
    name: "SIAL Interfood 2024",
    dates: "2024",
    end: "2024-12-31",
    venue: "JIExpo Kemayoran, Jakarta",
  },
  {
    id: "sial-2023",
    name: "SIAL Interfood 2023",
    dates: "2023",
    end: "2023-12-31",
    venue: "JIExpo Kemayoran, Jakarta",
  },
  {
    id: "sial-2022",
    name: "SIAL Interfood 2022",
    dates: "2022",
    end: "2022-12-31",
    venue: "JIExpo Kemayoran, Jakarta",
  },
];

export const isPastEvent = (ev) => new Date(`${ev.end}T23:59:59`) < new Date();
